<template>
    <section id="reviews-micro-combo" class="mt-10 lg:mt-12" v-show="isTrustpilotWidgetEnabled">
        <!-- TrustBox widget - Micro Combo -->
        <div id="reviews-micro-combo-widget" class="trustpilot-widget" data-locale="en-US"
            data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="583140ae0000ff000597c764"
            data-style-height="20px" data-style-width="100%">
        </div>
        <!-- End TrustBox widget -->
    </section>
</template>

<script>

import ObserverMixin from '../../mixins/trustpilot-observer';

export default {
    mixins: [ObserverMixin],

    mounted() {
        if (window.isTrustpilotWidgetEnabled) {
            this.refreshTrustpilot();
        }

        this.initiObserver('reviews-micro-combo-widget');
    },

    methods: {
        refreshTrustpilot() {
            this.isTrustpilotWidgetEnabled = true;

            this.$nextTick(() => {
                var element = document.getElementById('reviews-micro-combo-widget');
                window.Trustpilot.loadFromElement(element, true);
            });
        }
    },
}
</script>
